export default "__VITE_ASSET__YpX6ku9l__"